import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsbreadcrumb-container',
	templateUrl:'./BSBreadcrumbContainerPluginCompPage.html',
	styles: [],
	styleUrls:['./BSBreadcrumbContainerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSBreadcrumbContainerPluginCompPage
{
	mdContent_779 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.breadcrumbs.BSBreadcrumbContainer;
\`\`\``;
	mdContent_780 = `\`\`\`java
BSBreadcrumbContainer()
\`\`\``;
	mdContent_781 = `\`\`\`java
BSBreadcrumbContainer&lt;?&gt; bc = new BSBreadcrumbContainer&lt;&gt;();
bc.add(new BSBreadcrumbItem&lt;&gt;("Home", "/"));
bc.add(new BSBreadcrumbItem&lt;&gt;("Products", "/products"));
bc.add(new BSBreadcrumbItem&lt;&gt;("Detail").setActive(true));
\`\`\``;
}
